import axios from "axios";

import { API_BASE_URL } from '../../config/apiConfig';

// Employee Authentication Operations
// ---------------------------------

export const validateEmployee = async (credentials) => {
    try {
        // Convert to backend expected format
        const backendPayload = {
            Username: credentials.employeeId,  // Convert employeeId to Username
            Password: credentials.password     // Convert password to Password (capital P)
        };

         // DEBUG
         // DEBUG

        const response = await axios.post(
            `${API_BASE_URL}/Security/GetValidEmployee`,
            backendPayload,
            {
                headers: {
                    'Content-Type': 'application/json'
                }
            }
        );
        
         // DEBUG
        return response.data;
    } catch (error) {
        
        if (error.response?.data) {
            throw error.response.data;
        }
        throw error;
    }
};

// Role/User Authentication Operations
// ---------------------------------

export const validateUser = async (credentials) => {
    try {
        // Convert to backend expected format
        const backendPayload = {
            Username: credentials.employeeId,  // Convert employeeId to Username
            Password: credentials.password     // Convert password to Password (capital P)
        };

         // DEBUG

        const response = await axios.post(
            `${API_BASE_URL}/Security/GetValidUser`,
            backendPayload,
            {
                headers: {
                    'Content-Type': 'application/json'
                }
            }
        );
        
        return response.data;
    } catch (error) {
        if (error.response?.data) {
            throw error.response.data;
        }
        throw error;
    }
};

// Employee Details Operations
// -------------------------

export const getEmployeeDetails = async (username) => {
    try {
         // DEBUG
        
        const response = await axios.get(
            `${API_BASE_URL}/Accounts/GetEmployeeDetailsbyUser?UserName=${username}`,
            {
                headers: {
                    'Content-Type': 'application/json'
                }
            }
        );
        return response.data;
    } catch (error) {
        if (error.response?.data) {
            throw error.response.data;
        }
        throw error;
    }
};

// Menu/Role Operations
// ------------------

export const getMenu = async (roleId) => {
    try {
         // DEBUG
        
        const response = await axios.get(
            `${API_BASE_URL}/Accounts/GetMenu?roleId=${roleId}`,
            {
                headers: {
                    'Content-Type': 'application/json'
                }
            }
        );
        
        return response.data;
    } catch (error) {
        if (error.response?.data) {
            throw error.response.data;
        }
        throw error;
    }
};

// Which dashboard template this role's users should see after login — fetched alongside
// getMenu, not embedded in it (menu is a flat per-item list; this is one value per role).
export const getUserRoleDashboardType = async (roleId) => {
    try {
         // DEBUG

        const response = await axios.get(
            `${API_BASE_URL}/Accounts/GetUserRoleDashboardType?roleId=${roleId}`,
            {
                headers: {
                    'Content-Type': 'application/json'
                }
            }
        );

        return response.data;
    } catch (error) {
        if (error.response?.data) {
            throw error.response.data;
        }
        throw error;
    }
};